module.exports = __webpack_public_path__ + "static/img/吴永浩A.1113e191.png";